var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgeSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FAF5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4925 28.063C18.3425 28.063 18.2225 28.033 18.1325 27.9955C17.8325 27.883 17.3225 27.5155 17.3225 26.353V21.5155H15.5675C14.5625 21.5155 14.2025 21.043 14.075 20.7655C13.9475 20.4805 13.835 19.903 14.495 19.1455L20.1725 12.6955C20.9375 11.8255 21.56 11.8855 21.86 11.998C22.16 12.1105 22.67 12.478 22.67 13.6405V18.478H24.425C25.43 18.478 25.79 18.9505 25.9175 19.228C26.045 19.513 26.1575 20.0905 25.4975 20.848L19.82 27.298C19.2875 27.9055 18.8225 28.063 18.4925 28.063ZM21.4475 13.0555C21.425 13.0855 21.2675 13.1605 21.02 13.4455L15.3425 19.8955C15.1325 20.1355 15.1025 20.2855 15.1025 20.3155C15.1175 20.323 15.2525 20.398 15.5675 20.398H17.885C18.1925 20.398 18.4475 20.653 18.4475 20.9605V26.3605C18.4475 26.7355 18.515 26.9005 18.545 26.9455C18.5675 26.9155 18.725 26.8405 18.9725 26.5555L24.65 20.1055C24.86 19.8655 24.89 19.7155 24.89 19.6855C24.875 19.678 24.74 19.603 24.425 19.603H22.1075C21.8 19.603 21.545 19.348 21.545 19.0405V13.6405C21.5525 13.2655 21.4775 13.108 21.4475 13.0555Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgeSettingsIcon);
export default __webpack_public_path__ + "static/media/surge-settings-icon.63b7cdafbe9c175757156f1473b144f0.svg";
export { ForwardRef as ReactComponent };